/* unplugin-vue-components disabled */import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/images/fullscreen.png';
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  style: {
    "width": "100%",
    "height": "78vh",
    "display": "flex",
    "flex-wrap": "wrap",
    "background-color": "#000",
    "border": "0.1rem solid #606266",
    "border-radius": "1rem"
  },
  class: "videoCard"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  style: {
    "color": "#ffffff",
    "font-size": "3rem",
    "font-weight": "bold"
  }
};
const _hoisted_7 = {
  key: 2,
  class: "weather-panel"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "weather-item"
};
const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = {
  class: "weather-item"
};
const _hoisted_12 = {
  class: "value"
};
const _hoisted_13 = {
  class: "weather-item"
};
const _hoisted_14 = {
  class: "value"
};
const _hoisted_15 = {
  class: "weather-item"
};
const _hoisted_16 = {
  class: "value"
};
const _hoisted_17 = {
  class: "weather-item"
};
const _hoisted_18 = {
  class: "value"
};
const _hoisted_19 = {
  class: "weather-item"
};
const _hoisted_20 = {
  class: "value"
};
const _hoisted_21 = {
  class: "weather-item"
};
const _hoisted_22 = {
  class: "value"
};
const _hoisted_23 = {
  class: "weather-item"
};
const _hoisted_24 = {
  class: "value"
};
const _hoisted_25 = {
  class: "weather-item"
};
const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "weather-item"
};
const _hoisted_28 = {
  class: "value"
};
const _hoisted_29 = {
  class: "weather-item"
};
const _hoisted_30 = {
  class: "value"
};
import { getVideoDeviceList, deviceVideoPlay, podTurns, getLastPoleWeather } from "@/api/base/device";
import player from "@/components/jessibuca/index.vue";
import screenfull from "screenfull";
// 每个播放槽位增加 weather 字段

export default {
  __name: 'index',
  setup(__props) {
    const videoList = ref(Array.from({
      length: 9
    }, () => ({
      url: '',
      deviceName: '',
      channelId: '',
      deviceType: '',
      weather: null // ← 新增
    })));
    const route = useRoute();
    const {
      proxy
    } = getCurrentInstance();
    /* 1. 用来存储分屏 ID 与设备名称的映射 */
    const screenDeviceMap = ref(new Map());
    const screenUidMap = ref(new Map());
    const deviceList = ref([]);
    const searchList = ref([]);
    const videoUrl = ref(['']);
    const spilt = ref(1);
    const playerIdx = ref(0);
    const loading = ref(false);
    const weatherView = ref(true);
    const deviceName = ref("");
    //存储上一次ptz的操作
    const ptzCode = ref("");
    const weatherTimers = ref({}); // 记录每个 idx 的定时器

    const liveStyle = computed(() => {
      let style = {
        width: '100%',
        height: '100%'
      };
      switch (spilt.value) {
        case 4:
          style = {
            width: '50%',
            height: '50%'
          };
          break;
        case 9:
          style = {
            width: '33.333333%',
            height: '33.333333%'
          };
          break;
      }
      nextTick(() => {
        for (let i = 0; i < spilt.value; i++) {
          const player = proxy.$refs.player;
          player && player[i] && player[i].updatePlayerDomSize();
        }
      });
      return style;
    });
    function getWeatherByIdx(idx) {
      console.log("拉取气象信息", idx);
      const uid = screenUidMap.value.get(idx);
      if (!uid) return;
      getLastPoleWeather(uid).then(res => {
        videoList.value[idx].weather = res.data;
      });
    }
    // 启动轮询
    function startWeatherTimer(idx) {
      stopWeatherTimer(idx); // 先清旧
      weatherTimers.value[idx] = setInterval(() => getWeatherByIdx(idx), 60 * 1000);
    }
    // 停止轮询
    function stopWeatherTimer(idx) {
      if (weatherTimers.value[idx]) {
        clearInterval(weatherTimers.value[idx]);
        delete weatherTimers.value[idx];
      }
    }
    watch(deviceName, val => {
      let temList = [];
      deviceList.value.map(item => {
        if (item.name.indexOf(val) >= 0) {
          temList.push(item);
        }
      });
      groupData(temList);
    });
    watch(spilt.value, newValue => {
      console.log("切换画幅;" + newValue);
      for (let i = 1; i <= newValue; i++) {
        if (!proxy.$refs['player' + i]) {
          continue;
        }
        nextTick(() => {
          if (proxy.$refs['player' + i] instanceof Array) {
            proxy.$refs['player' + i][0].resize();
          } else {
            proxy.$refs['player' + i].resize();
          }
        });
      }
      localStorage.setItem('split', newValue);
    });
    onUnmounted(() => {
      Object.keys(weatherTimers.value).forEach(idx => stopWeatherTimer(idx));
    });
    function getDeviceList() {
      getVideoDeviceList().then(res => {
        deviceList.value = res.data;
        groupData(deviceList.value);
      });
    }
    function ptzHandle(index, code) {
      console.log("父组件云台");
      console.log("父组件index", index);
      console.log("父组件code", code);
      let name = screenDeviceMap.value.get(index - 1);
      if (code === "apertureFar") {
        code = "backToTheCenter";
      } else if (code === "apertureNear") {
        code = "down90";
      } else if (ptzCode.value.startsWith("zoom") && code === 'stop') {
        code = 'zoomStop';
      }
      ptzCode.value = code;
      podTurns(name, code);
    }
    function groupData(list) {
      const list12 = {
        id: "a",
        name: "时空服务中心",
        children: []
      };
      const list0 = {
        id: "b",
        name: "固定翼无人机",
        children: []
      };
      const list1 = {
        id: "c",
        name: "多旋翼无人机",
        children: []
      };
      const list2 = {
        id: "d",
        name: "固定翼有人机",
        children: []
      };
      const list3 = {
        id: "e",
        name: "直升机",
        children: []
      };
      const list4 = {
        id: "f",
        name: "任务车",
        children: []
      };
      const list5 = {
        id: "g",
        name: "智慧杆",
        children: []
      };
      list.forEach((item, index) => {
        if ("12" === item.deviceType) {
          list12.children.push(item);
        } else if ("0" === item.deviceType) {
          item.status === '1' ? list0.children.unshift(item) : list0.children.push(item);
        } else if ("1" === item.deviceType) {
          item.status === '1' ? list1.children.unshift(item) : list1.children.push(item);
        } else if ("2" === item.deviceType) {
          item.status === '1' ? list2.children.unshift(item) : list2.children.push(item);
        } else if ("3" === item.deviceType) {
          item.status === '1' ? list3.children.unshift(item) : list3.children.push(item);
        } else if ("4" === item.deviceType) {
          item.status === '1' ? list4.children.unshift(item) : list4.children.push(item);
        } else if ("13" === item.deviceType) {
          item.status === '1' ? list5.children.unshift(item) : list5.children.push(item);
        }
      });
      searchList.value = [];
      if (list12.children.length > 0) {
        searchList.value.push(list12);
      }
      if (list5.children.length > 0) {
        searchList.value.push(list5);
      }
      if (list0.children.length > 0) {
        searchList.value.push(list0);
      }
      if (list1.children.length > 0) {
        searchList.value.push(list1);
      }
      if (list2.children.length > 0) {
        searchList.value.push(list2);
      }
      if (list3.children.length > 0) {
        searchList.value.push(list3);
      }
      if (list4.children.length > 0) {
        searchList.value.push(list4);
      }
    }
    const tableRowClassName = ({
      row,
      rowIndex
    }) => {
      if (row.status === undefined) {
        return 'success-row';
      }
      return '';
    };
    function fullScreenClick() {
      setTimeout(() => {
        requestAnimationFrame(() => {
          const dom = document.getElementsByClassName("videoCard")[0];
          if (screenfull.isEnabled) {
            screenfull.request(dom);
          }
        });
      }, 50);
    }
    function checkPlayByParam() {
      console.log("*******************************************************");
      console.log(route.params);
      console.log(route.params.query);
      console.log(localStorage.getItem('playData'));
      console.log(localStorage.getItem('split'));
      console.log(localStorage.getItem('videoUrl'));
      console.log("*******************************************************");
      let {
        deviceName,
        channelId
      } = route.params;
      if (deviceName && channelId) {
        this.sendDevicePush({
          deviceName,
          channelId
        });
      }
    }
    function clickEvent(row) {
      if (row.status === undefined) {
        return;
      }
      console.log("clickEvent:{}", row);
      if (row.status === "0") {
        proxy.$modal.msgError('设备离线!不允许点播！');
        return;
      }
      if (row.statusAll.podStatus === 0) {
        proxy.$modal.msgError('吊舱视频未推送至平台，请检查吊舱视频链路！');
        return;
      }
      let deviceName = row.deviceName;
      let channelId = row.channelId;
      if (deviceName === "" || channelId === "" || deviceName === undefined || channelId === undefined) {
        proxy.$modal.msgWarning('请检查设备编码和设备通道！');
      } else {
        sendDevicePush(row);
      }
    }
    //通知设备上传媒体流
    /*function sendDevicePush (itemData) {
      save(itemData)
      let deviceName = itemData.deviceName;
      let channelId = itemData.channelId;
      screenDeviceMap.value.set(playerIdx.value, deviceName);
      console.log("通知设备推流1：" + deviceName + " : " + channelId);
      loading.value = true
      deviceVideoPlay({deviceName: deviceName, channelId: channelId,deviceType:itemData.deviceType}).then(res => {
    
        console.log("获得设备流")
        console.log(res)
        if (res.code === 200 && res.data) {
    
          let url = res.data ? (res.data.wss_flv) : "";
          setPlayUrl(url, playerIdx.value);
        } else {
          proxy.$modal.msgError(res.msg);
        }
      }).catch(function (e) {
      }).finally(() => {
        loading.value = false
      });
    }*/

    function sendDevicePush(itemData) {
      const idx = playerIdx.value;
      const {
        deviceName,
        channelId,
        deviceType
      } = itemData;

      // 保存到本地
      save(itemData);
      screenDeviceMap.value.set(idx, deviceName);
      screenUidMap.value.set(idx, itemData.uid);

      // 先清空旧数据
      videoList.value[idx].url = '';
      videoList.value[idx].deviceName = deviceName;
      videoList.value[idx].channelId = channelId;
      videoList.value[idx].deviceType = deviceType;
      videoList.value[idx].weather = null;

      // 如果是智慧杆，立即拉一次气象，再启动轮询
      if (deviceType === '13') {
        getWeatherByIdx(idx); // 立刻一次
        startWeatherTimer(idx); // 每分钟续刷
      }
      loading.value = true;
      deviceVideoPlay({
        deviceName,
        channelId,
        deviceType
      }).then(res => {
        if (res.code === 200 && res.data) {
          videoList.value[idx].url = res.data.wss_flv || '';
          localStorage.setItem('videoUrl', JSON.stringify(videoList.value.map(v => v.url)));
        } else {
          proxy.$modal.msgError(res.msg);
        }
      }).finally(() => loading.value = false);
    }
    function setPlayUrl(url, idx) {
      videoUrl.value[idx] = "";
      setTimeout(() => {
        videoUrl.value[idx] = url;
      }, 100);
      setTimeout(() => {
        localStorage.setItem('videoUrl', JSON.stringify(videoUrl.value));
      }, 100);
      console.log("*****************************************");
      console.log(videoUrl.value);
      console.log("*****************************************");
    }
    function shot(e) {
      // console.log(e)
      // send({code:'image',data:e})
      var base64ToBlob = function (code) {
        let parts = code.split(';base64,');
        let contentType = parts[0].split(':')[1];
        let raw = window.atob(parts[1]);
        let rawLength = raw.length;
        let uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
          type: contentType
        });
      };
      let aLink = document.createElement('a');
      let blob = base64ToBlob(e); //new Blob([content]);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = '截图';
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    }
    function save(item) {
      let dataStr = localStorage.getItem('playData') || '[]';
      let data = JSON.parse(dataStr);
      data[playerIdx.value] = item;
      localStorage.setItem('playData', JSON.stringify(data));
    }
    function destroy(idx) {
      console.log(idx);
      clear(idx.substring(idx.length - 1));
    }
    function clear(idx) {
      let dataStr = localStorage.getItem('playData') || '[]';
      let data = JSON.parse(dataStr);
      data[idx - 1] = null;
      console.log(data);
      localStorage.setItem('playData', JSON.stringify(data));
    }
    getDeviceList();
    //checkPlayByParam()

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: _unref(searchList),
            "row-key": "id",
            "default-expand-all": "",
            "highlight-current-row": "",
            onRowDblclick: clickEvent,
            "row-class-name": tableRowClassName,
            "header-cell-style": {
              background: 'transparent !important',
              color: '#FFFFFF',
              border: '0.1rem solid #1d5390'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, null, {
              header: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(deviceName),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(deviceName) ? deviceName.value = $event : null),
                clearable: "",
                placeholder: "请输入设备名称"
              }, null, 8, ["modelValue"])]),
              default: _withCtx(({
                row
              }) => [_createElementVNode("span", {
                class: _normalizeClass(row.status === undefined ? 'text-back' : row.status === '1' ? 'text-green' : 'text-red')
              }, _toDisplayString(row.name), 3)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_container, null, {
            default: _withCtx(() => [_createVNode(_component_el_header, {
              height: "4.5vh",
              style: {
                "text-align": "left",
                "font-size": "1.7rem",
                "line-height": "5rem"
              }
            }, {
              default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("span", {
                style: {
                  "color": "#FFFFFF"
                }
              }, "分屏:", -1)), _createVNode(_component_el_tooltip, {
                class: "item",
                effect: "dark",
                content: "单屏",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: _normalizeClass(["btn", {
                    active: _unref(spilt) == 1
                  }]),
                  onClick: _cache[1] || (_cache[1] = $event => spilt.value = 1),
                  icon: "FullScreen"
                }, null, 8, ["class"])]),
                _: 1
              }), _createVNode(_component_el_tooltip, {
                class: "item",
                effect: "dark",
                content: "四分屏",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: _normalizeClass(["btn", {
                    active: _unref(spilt) == 4
                  }]),
                  onClick: _cache[2] || (_cache[2] = $event => spilt.value = 4),
                  icon: "Menu"
                }, null, 8, ["class"])]),
                _: 1
              }), _createVNode(_component_el_tooltip, {
                class: "item",
                effect: "dark",
                content: "九分屏",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: _normalizeClass(["btn", {
                    active: _unref(spilt) == 9
                  }]),
                  onClick: _cache[3] || (_cache[3] = $event => spilt.value = 9),
                  icon: "Grid"
                }, null, 8, ["class"])]),
                _: 1
              }), _createVNode(_component_el_tooltip, {
                class: "item",
                effect: "dark",
                content: "全屏",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: "btn",
                  onClick: fullScreenClick
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_main, {
              style: {
                "padding": "0"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spilt), i => {
                return _openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["play-box", {
                    redborder: _unref(playerIdx) == i - 1
                  }]),
                  style: _normalizeStyle(_unref(liveStyle)),
                  onClick: $event => playerIdx.value = i - 1
                }, [!_unref(videoList)[i - 1].url ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : (_openBlock(), _createBlock(player, {
                  key: 1,
                  ref_for: true,
                  ref: "playerRef",
                  url: _unref(videoList)[i - 1].url,
                  close: true,
                  fluent: "",
                  autoplay: "",
                  onScreenshot: shot,
                  ptz: true,
                  "ptz-index": i,
                  onPtzHandle: ptzHandle,
                  onDestroy: destroy
                }, null, 8, ["url", "ptz-index"])), _unref(videoList)[i - 1].deviceType === '13' && _unref(videoList)[i - 1].weather ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
                  class: "weather-header",
                  onClick: _cache[4] || (_cache[4] = $event => weatherView.value = !_unref(weatherView))
                }, "实时气象"), _unref(weatherView) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[7] || (_cache[7] = _createElementVNode("span", {
                  class: "label"
                }, "设备名称", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(videoList)[i - 1].weather.deviceName), 1)]), _createElementVNode("div", _hoisted_11, [_cache[8] || (_cache[8] = _createElementVNode("span", {
                  class: "label"
                }, "设备编号", -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(videoList)[i - 1].weather.deviceAddr), 1)]), _createElementVNode("div", _hoisted_13, [_cache[9] || (_cache[9] = _createElementVNode("span", {
                  class: "label"
                }, "风速", -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(videoList)[i - 1].weather.windSpeed) + " m/s", 1)]), _createElementVNode("div", _hoisted_15, [_cache[10] || (_cache[10] = _createElementVNode("span", {
                  class: "label"
                }, "风向", -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(videoList)[i - 1].weather.windDir), 1)]), _createElementVNode("div", _hoisted_17, [_cache[11] || (_cache[11] = _createElementVNode("span", {
                  class: "label"
                }, "风力", -1)), _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(videoList)[i - 1].weather.windLevel) + " 级", 1)]), _createElementVNode("div", _hoisted_19, [_cache[12] || (_cache[12] = _createElementVNode("span", {
                  class: "label"
                }, "湿度", -1)), _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(videoList)[i - 1].weather.humidity) + "%", 1)]), _createElementVNode("div", _hoisted_21, [_cache[13] || (_cache[13] = _createElementVNode("span", {
                  class: "label"
                }, "温度", -1)), _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(videoList)[i - 1].weather.temperature) + " ℃", 1)]), _createElementVNode("div", _hoisted_23, [_cache[14] || (_cache[14] = _createElementVNode("span", {
                  class: "label"
                }, "噪声", -1)), _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(videoList)[i - 1].weather.noise) + " dB", 1)]), _createElementVNode("div", _hoisted_25, [_cache[15] || (_cache[15] = _createElementVNode("span", {
                  class: "label"
                }, "气压", -1)), _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(videoList)[i - 1].weather.pressure) + " Kpa", 1)]), _createElementVNode("div", _hoisted_27, [_cache[16] || (_cache[16] = _createElementVNode("span", {
                  class: "label"
                }, "累计雨量", -1)), _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(videoList)[i - 1].weather.rainfall) + " mm", 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_unref(videoList)[i - 1].weather.rainfall < 10 && _unref(videoList)[i - 1].weather.windSpeed < 10 ? "无人机可以正常作业" : "无人机作业条件需要现场确认，谨慎飞行"), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 14, _hoisted_5);
              }), 128))])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])])])]);
    };
  }
};